import {
  faTableColumns,
  faTableColumnsAddAfter,
  faTableColumnsAddBefore,
  faTableColumnsRemoveAfter
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import clsx from 'clsx'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { editorDropdownItem, editorTableMenuDanger } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const TableColumnDropdown = ({ editor }: { editor: Editor }) => (
  <Tooltip direction="bottom" text="Colonnes" asChild>
    <SplitButtonDropdown
      icon={<FontAwesomeIcon icon={faTableColumns} />}
      onMainClick={() => editor.chain().focus().addColumnAfter().run()}
    >
      <button
        type="button"
        className={editorDropdownItem}
        onClick={() => editor.chain().focus().addColumnBefore().run()}
      >
        <FontAwesomeIcon icon={faTableColumnsAddBefore} />
        Ajouter une colonne avant
      </button>
      <button
        type="button"
        className={editorDropdownItem}
        onClick={() => editor.chain().focus().addColumnAfter().run()}
      >
        <FontAwesomeIcon icon={faTableColumnsAddAfter} />
        Ajouter une colonne après
      </button>
      <button
        type="button"
        className={clsx(editorDropdownItem, editorTableMenuDanger)}
        onClick={() => editor.chain().focus().deleteColumn().run()}
      >
        <FontAwesomeIcon icon={faTableColumnsRemoveAfter} />
        Supprimer la colonne
      </button>
    </SplitButtonDropdown>
  </Tooltip>
)
